export default __webpack_public_path__ + "static/media/download-list-bg.df19efa1.png";